<div class="dropdown container-fluid">
  <form [formGroup]="filterForm">
    <div class="row flex mb-3">
      @for(item of filters; track $index){
      <div
        [ngClass]="item?.colClass || (item?.type === 'multiselect-toggle' ? 'col' : (item?.key === 'insights' ? 'col-auto d-flex align-items-start' : 'col-auto'))"
        [style.margin-top]="item?.key === 'insights' ? '24px' : '0'">
        @switch (item?.type) {
        @case ('multiselect-toggle') {
        <multiselect-toggle [data]="item" [optionsMap]="options"></multiselect-toggle>
        }
        @case ('dropdown') {
        <app-global-dropdown [formControlName]="item.key" [options]="options[item.key] || []" [data]="item">
        </app-global-dropdown>
        }
        @case ('slider-range') {
        <app-mat-slider [data]="item">
        </app-mat-slider>
        }
        @case ('button') {
        @if (isOptionButtonFilter(item)) {
        <app-filter-option-buttons
          [formControlName]="item.key"
          [options]="options[item.key] || item.optionsList || []"
          [data]="item">
        </app-filter-option-buttons>
        } @else {
        <app-button [data]="item" [selectedKey]="selectedKey"
          [showResetButton]="showResetButton && hasInsightsButton && item?.key === 'insights'"
          (selectionChange)="onButtonSelectionChange($event)" (resetClick)="resetButton()">
        </app-button>
        }

        }
        @case ('icon') {
        <mat-icon (click)="download(item.apiUrl)" style="cursor:pointer;margin-top: 2.2rem;">download</mat-icon>
        }
        @case ('search') {
        <app-search-container [data]="item" (search)="onSearch($event, item.key)">
        </app-search-container>
        }

        @default {}
        }
      </div>
      }

      <div class="col-auto d-flex align-items-center" *ngIf="showResetButton">
        <div (click)="resetButton()" class="reset d-flex align-items-center"
          style="cursor: pointer;">

          <mat-icon class="material-symbols-outlined me-1">filter_alt</mat-icon>
          <span></span>
        </div>
      </div>
    </div>
  </form>
</div>
